const createObjectForPost = (
  cogs,
  finance_expenses,
  other_operating_data,
  operating_expenses
) => {
  return {
    cogs: cogs,
    operating_expenses: operating_expenses,
    finance_expenses: finance_expenses,
    other_operating_data: other_operating_data,
  };
};

export default createObjectForPost;
